export default "a6b980f8cf4e77b1.svg"